import React, { Component } from "react";
import { connect } from "react-redux";
import { Box } from "reflexbox";
import { Panel, PanelType } from "office-ui-fabric-react/lib/Panel";
import { withApollo } from "react-apollo";
import { signOutAction } from "../../actions/auth_actions";
import { ActionButton } from "office-ui-fabric-react/lib/Button";
import {
  Persona,
  PersonaPresence,
  PersonaSize
} from "office-ui-fabric-react/lib/Persona";

class Profile extends Component {
  constructor() {
    super();
    this.state = {
      isModalVisible: false
    };
  }

  logout = () => {
    this.props.signOut();
    this.props.client.resetStore();
    this.props.history.push("/");
  };

  toggleModal = () => {
    this.setState({ isModalVisible: !this.state.isModalVisible });
  };

  dismissModal = () => {
    this.setState({ isModalVisible: false });
  };

  _onRenderPrimaryText = props => {
    return <div style={{ color: "#C6E0FF" }}>{props.primaryText}</div>;
  };

  render() {
    const { name } = this.props;

    return (
      <Box style={{ marginTop: "10px", cursor: "pointer", height: "50px" }}>
        <Persona
          primaryText={name}
          tertiaryText={name}
          size={PersonaSize.size28}
          onClick={this.toggleModal}
          presence={PersonaPresence.online}
          title="Edit profile"
          coinSize={28}
          onRenderPrimaryText={this._onRenderPrimaryText}
        />
        <Panel
          className="form-panel"
          isBlocking={true}
          isOpen={this.state.isModalVisible}
          onDismiss={this.dismissModal}
          isLightDismiss={true}
          type={PanelType.small}
          forceFocusInsideTram={true}
          headerText={`Profile ${this.props.name}`}
        >
          <Box>
            <ActionButton
              onClick={this.logout}
              text="Sign out"
              iconProps={{
                iconName: "signOut"
              }}
            />
          </Box>
        </Panel>
      </Box>
    );
  }
}

export default withApollo(
  connect(state => state.auth, {
    signOut: signOutAction
  })(Profile)
);



// WEBPACK FOOTER //
// ./src/views/App/_Profile.js